<template>
  <div v-if="mounted" id="default-layout">
    <slot></slot>
    <v-snackbar top centered v-model="refreshSnackbar" :timeout="20000" color="transparent">Pull down and release to refresh content</v-snackbar>
  </div>
</template>

<script>
  // import layout from '@/Layouts/MainLayout'
  import _ from 'lodash'

  export default {
    name: 'DefaultLayout',
    data () {
      return {
        mounted: false,
        refreshSnackbar: false,
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.mounted = true
      })
    },
    created () {
      this.$once('hook:mounted', () => {
        let vm = this
        let _startY;
        const body = document.querySelector('body');

        body.addEventListener('touchstart', e => {
          _startY = e.touches[0].pageY;
        }, { passive: true });

        body.addEventListener('touchmove', e => {
          const y = e.touches[0].pageY;
          // Activate custom pull-to-refresh effects when at the top of the container
          // and user is scrolling up.
          if (document.scrollingElement.scrollTop === 0 && y > _startY) {
            e.preventDefault()
            vm.refreshSnackbar = true
            body.classList.add('pull-down')
            vm.reloadPage()
          }
        }, { passive: false });
      })
    },
    methods: {
      reloadPage: _.debounce(function () {
        let body = document.querySelector('body')
        body.classList.remove('pull-down')
        this.refreshSnackbar = false
        this._reloadCurrent()
      }, 1000),
    }
  }
</script>
